import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { red } from "../../theme";
import { useHistory } from "react-router-dom";
import { Dispatch } from "react";
import { Grid } from "@mui/material";



const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

interface INotificationModal {
  display: boolean
  setDisplay: any
}

export default function ExpenseConfirmation(props: INotificationModal) {
  const { display, setDisplay} = props;

  const history = useHistory()
  return (
    <div>
      <Modal open={display} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <>
        <Box sx={style}>
          <Typography textAlign={"center"}variant={'h4'} sx={{marginBottom: '1em'}}>Expense Submitted</Typography>
          
          <Typography  textAlign={"center"}>
      Expense submitted successfully. Would you like to submit another expense?
          </Typography>
          <Grid container justifyContent={'space-between'}>
          <Button type="button" variant="contained" onClick={() => {setDisplay(false); history.push("/submit_expense")}} sx={{ marginTop: 5, width: "40%" }} color="primary">
            Yes
          </Button>
          <Button type="button" variant="contained" onClick={() => {setDisplay(false); history.push("/user_page")}} sx={{ marginTop: 5, width: "40%" }} color="primary">
            No
          </Button>
          </Grid>
        </Box>
        </>
      </Modal>
    </div>
  );
}
